export const VALIDATE_TIN = 'taxInformation/VALIDATE_TIN';
export const SET_TIN = 'taxInformation/SET_TIN';
export const RESET_TIN_INFO = 'taxInformation/RESET_TIN_INFO';
